import React from "react";
import PropTypes from "prop-types";
import "./CircleButton.sass"
import {Link} from "react-router-dom";

export default function CircleButton({Icon, link, onClick, title, backgroundColor, disabled}) {

    let style = {
        backgroundColor: backgroundColor || ''
    }

    if (link) {
        return (
            <Link to={link} title={title}
                  style={style}
                  onClick={onClick ? onClick : () => {}}
                  className={`circle-button-wrapper ${disabled && "circle-button-wrapper-disabled"}`}>
                <div>
                    <Icon/>
                </div>
            </Link>
        )
    } else {
        return (
            <div onClick={onClick ? onClick : () => {}}
                 style={style}
                 title={title}
                 className={`circle-button-wrapper ${disabled && "circle-button-wrapper-disabled"}`}>
                <div>
                    <Icon/>
                </div>
            </div>
        )
    }
}

CircleButton.propTypes = {
    Icon: PropTypes.object.isRequired,
    link: PropTypes.string,
    onClick: PropTypes.func,
    title: PropTypes.string,
    backgroundColor: PropTypes.string,
    disabled: PropTypes.bool,
}